import { render, staticRenderFns } from "./TransferAccounts.vue?vue&type=template&id=083dd39d&scoped=true&"
import script from "./TransferAccounts.vue?vue&type=script&lang=js&"
export * from "./TransferAccounts.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccounts.vue?vue&type=style&index=0&id=083dd39d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dd39d",
  null
  
)

export default component.exports